module.exports = __webpack_public_path__ + "img/Hero Image 3.ef477e62.jpeg";